import { Box } from '@mui/material';
import { type FC } from 'react';
import { getAchievementRarityColor } from '../../helpers/achievement';
import { VoiceAction } from '../../types/voice';
import { CommonIcon } from '../common/CommonIcon';

type ActionCardIconColors = { bg: string; icon: string };

interface ActionCardIconProps {
  action: VoiceAction;
  actionIcon: string;
  colors: ActionCardIconColors;
}

export const ActionCardIcon: FC<ActionCardIconProps> = ({ action, actionIcon, colors }) => {
  if (action.type === 'CREATE_ACHIEVEMENT') {
    return (
      <Box
        sx={{
          width: 36,
          height: 36,
          flexShrink: 0,
          borderRadius: '11px',
          backgroundColor: getAchievementRarityColor(action.rarity),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CommonIcon icon={action.icon} type="outlined" size={18} color="#ffffff" />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: 36,
        height: 36,
        borderRadius: '11px',
        flexShrink: 0,
        background: colors.bg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CommonIcon icon={actionIcon} type="filled" size={18} color={colors.icon} />
    </Box>
  );
};
